import {
  Box,
  Button,
  Container,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useSelector, useDispatch } from "react-redux";
import { createDepartment } from "../../actions/department";
import { deleteDepartment } from "../../actions/department";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { updateDepartment } from "../../actions/department";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";
import API from "../../Api/api";
import { Modal } from "antd";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#75CA93 ",
    color: theme.palette.common.black,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(id, department, limit) {
  return { id, department, limit };
}

export default function Department() {
  const [editingId, setEditingId] = React.useState(null);
  const [deletingId, setDeletingId] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const showModal = () => {
    setOpenModal(true);
  };
  const handleOk = () => {
    setOpenModal(false);
  };
  const handleCancel = () => {
    setOpenModal(false);
    setDeletingId(null);
  };
  const [departmentName, setDepartmentName] = React.useState("");
  const [index, setIdex] = React.useState(null);
  const [department, setDepartment] = React.useState({
    department: "",
    limit: "",
  });
  const departments = useSelector((state) => state.departments.depart);

  const [data, setData] = React.useState(departments);
  React.useEffect(() => {
    setData(departments);
  }, [departments]);
  const rows = data.map((data) =>
    createData(data._id, data.department, data.limit)
  );
  const dispatch = useDispatch();
  function sendData() {
    if (!department.department) {
      toast.error("Please enter department");
      return;
    }
    //  if department then we will dispatch the data
    dispatch(createDepartment(department));
    setDepartment({
      department: "",
      limit: "",
    });
  }

  function editData(id) {
    setEditingId(id);
  }
  const updateArray = (arr) => {
    return Promise.all(arr.map((item) => updateItem(item)));
  };

  const updateItem = async (item) => {
    try {
      // Simulate a fetch request to update the item (replace this with your actual API call)
      await API.patch(`api/v1/eClaim/${item._id}`, {
        department: data[index].department,
      });
    } catch (error) {
      toast.error(error.message);
    }
  };
  async function handleSaveData(id, index) {
    try {
      if (!editingId) {
        toast.error("Please you have not made any changes");
        return;
      }
      const allClaimsData = await API.get(
        `api/v1/eClaim?department[eq]=${departmentName}`
      );
      dispatch(updateDepartment(id, data[index]));
      // Update all objects in the array
      if (allClaimsData.data.length > 0) {
        updateArray(allClaimsData.data)
          .then((updatedArray) => {
            toast.success("all transactions with the same department updated");
          })
          .catch((err) => {
            toast.error("Error updating items please try again:");
          });
      }
      setEditingId(null);
    } catch (error) {}
  }

  return (
    <div
      style={{
        display: "absolute",
        top: 50,
        marginTop: "80px",
      }}>
      <Modal
        maskClosable={false}
        closable={false}
        open={openModal}
        title='Deleting Confirmation'
        onOk={handleOk}
        onCancel={handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button
              onClick={() => {
                dispatch(deleteDepartment(deletingId));
                handleCancel();
              }}>
              Yes
            </Button>
            <Button
              style={{ color: "red" }}
              onClick={() => {
                handleCancel();
              }}>
              No
            </Button>
          </>
        )}>
        <p>Do you want to proceed with deleting this department?</p>
      </Modal>
      <Helmet title='Departments - eClaim' />
      <Container>
        <TextField
          label='Department'
          required
          style={{
            color: "#fff",

            marginRight: "20px",
            borderRadius: "10px",
            backgroundColor: "#fff",
          }}
          size='small'
          type='text'
          placeholder='department name'
          value={department.department}
          onChange={(e) =>
            setDepartment({ ...department, department: e.target.value })
          }
        />
        <TextField
          label='Claim limit'
          style={{
            color: "#fff",

            marginRight: "20px",
            borderRadius: "10px",
            backgroundColor: "#fff",
          }}
          size='small'
          type='number'
          placeholder='claim limit'
          value={department.limit}
          onChange={(e) =>
            setDepartment({ ...department, limit: e.target.value })
          }
        />
        <Button
          onClick={sendData}
          style={{ backgroundColor: "#75CA93 ", color: "#000" }}
          variant='contained'>
          Add
        </Button>
        <Box marginTop={1}>
          <TableContainer style={{ height: "70vh" }} component={Paper}>
            <Table
              size='small'
              sx={{ minWidth: 700 }}
              aria-label='customized table'>
              <TableHead style={{ backgroundColor: "#75CA93 " }}>
                <TableRow style={{ backgroundColor: "#75CA93 " }}>
                  {/* <StyledTableCell>ID</StyledTableCell> */}
                  <StyledTableCell align='left'>DEPARTMENT</StyledTableCell>
                  <StyledTableCell align='left'>Claim Limit</StyledTableCell>
                  <StyledTableCell align='right'>ACTION</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell align='left'>
                      {editingId === row.id ? (
                        <TextField
                          type='text'
                          value={row.department}
                          onChange={(e) =>
                            setData((prevData) =>
                              prevData.map((item) =>
                                item._id === row.id
                                  ? { ...item, department: e.target.value }
                                  : item
                              )
                            )
                          }
                          size='small'
                        />
                      ) : (
                        row.department
                      )}
                    </StyledTableCell>
                    <StyledTableCell align='left'>
                      {editingId === row.id ? (
                        <TextField
                          type='number'
                          value={row.limit}
                          onChange={(e) =>
                            setData((prevData) =>
                              prevData.map((item) =>
                                item._id === row.id
                                  ? { ...item, limit: e.target.value }
                                  : item
                              )
                            )
                          }
                          size='small'
                        />
                      ) : (
                        row.limit
                      )}
                    </StyledTableCell>
                    <StyledTableCell style={{}} align='right'>
                      <Tooltip title='delete'>
                        <IconButton
                          size='small'
                          onClick={() => {
                            setDeletingId(row.id);
                            showModal();
                          }}>
                          <DeleteOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title='Edit'>
                        <IconButton
                          size='small'
                          onClick={() => {
                            editData(row.id);
                            setDepartmentName(row.department);
                            setIdex(index);
                          }}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      {editingId === row.id && (
                        <Tooltip title='save changes'>
                          <IconButton
                            onClick={() => handleSaveData(row.id, index)}
                            size='small'>
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {editingId === row.id && (
                        <Tooltip title='cancel'>
                          <IconButton
                            size='small'
                            onClick={() => setEditingId(null)}>
                            <CancelIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </div>
  );
}
